<template>
    <div class="mx-2 flex flex-col gap-1 py-2" v-cloak>

        <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
            <span class="text-sm text-gray-100">Fetching...</span>
            <spinner />
        </div>

        <div v-if="!fetching" class="flex flex-col gap-1">

            <div class="uppercase text-xs font-semibold mb-2 relative flex items-center justify-center h-6">
                <span>Sponsors</span>
                <button
                    @click.prevent="newSponsor"
                    class="absolute right-0 top-0 bg-gray-800 text-white rounded-full flex items-center justify-center h-6 w-6"
                ><i class="fas fa-plus text-xs"></i></button>
            </div>
            <ul class="mb-2 flex flex-col gap-1">
                <li
                    v-for="(item, index) in sponsors"
                    class="flex flex-col py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'"
                    @click.prevent="showSponsor(item.id)"
                >
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-1">
                            <div class="font-semibold">{{ item.name }}</div>
                            <div class="text-xs text-gray-500">{{ item.wallet_short }}</div>
                        </div>
                        <div class="flex items-center gap-1">
                            <div>{{ item.subdomain }}</div>
                            <i v-if="item.active" class="fas fa-circle fa-fw text-green-500"></i>
                            <i v-else class="fas fa-circle fa-fw text-red-500"></i>
                        </div>
                    </div>
                </li>
            </ul>

            <div v-if="showPagination" class="flex items-center justify-between">
                <button
                    @click.prevent="prev"
                    class="bg-gray-800 text-white disabled:bg-opacity-50 disabled:text-gray-600 rounded-full flex items-center justify-center h-6 w-6"
                    :disabled="prev_page_url === null"
                ><i class="fas fa-chevron-left text-xs"></i></button>
                <button
                    @click.prevent="next"
                    class="bg-gray-800 text-white disabled:bg-opacity-50 disabled:text-gray-600 rounded-full flex items-center justify-center h-6 w-6"
                    :disabled="next_page_url === null"
                ><i class="fas fa-chevron-right text-xs"></i></button>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AdminSubPanelSponsors',
    props: ['token', 'page'],
    data() {
        return {
            fetching: false,
            current_page: null,
            next_page_url: null,
            prev_page_url: null,
            sponsors: [],
        }
    },
    computed: {
        showPagination() {
            return this.next_page_url !== null || this.prev_page_url !== null
        }
    },
    watch: {
        current_page(value) {
            this.fetchData(value)
        }
    },
    methods: {
        prev() {
            this.current_page--;
        },
        next() {
            this.current_page++;
        },
        fetchData(page = 1) {
            this.fetching = true
            axios.get('/api/admin/sponsors/index?page=' + page, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.sponsors = response.data.data
                this.current_page = response.data.current_page
                this.next_page_url = response.data.next_page_url
                this.prev_page_url = response.data.prev_page_url
            }).catch(() => {
                this.$toast.error('Error fetching Sponsors.')
            }).finally(() => {
                this.fetching = false
            })
        },
        showSponsor(sponsor_id) {
            const page = this.current_page
            this.$emit('sponsor-add-edit', { sponsor_id, page })
        },
        newSponsor() {
            this.$emit('sponsor-add-edit', null)
        }
    },
    mounted() {
        this.current_page = this.page
    }
}
</script>
